import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadCultures, saveCulture } from '../../actions/settingsActions';
import CustomSelect from '../CustomSelect';
import Preloader from '../Preloader';

class Cultures extends Component {
	state = {
		newCulture: '',
		changedCulture: ''
	}

	handleInputChange = e => {
		const value = e.target.value;
		const field = e.target.dataset.field;

		this.setState({
			[field]: value
		});
	}

	handleSelectChange = (name, value) => {
		const culture = this.props.cultures.find(el => el.value.toString() === value);
		this.setState({
			[name]: value,
			changedCulture: culture.label
		});
	}

	handleAddClick = e => {
		e.preventDefault();

		this.props.saveCulture({
			label: this.state.newCulture
		});
		this.setState({
			newCulture: ''
		});
	}

	handleSaveClick = e => {
		e.preventDefault();

		this.props.saveCulture({ label: this.state.changedCulture, value: this.state.culture });
		this.setState({
			changedCulture: '',
			culture: ''
		});
	}

	handleRemoveClick = e => {
		e.preventDefault();

		this.props.deleteCulture({ value: this.state.culture });
		this.setState({
			changedCulture: '',
			culture: ''
		});
	}

	render() {
		const { newCulture, culture, changedCulture } = this.state;
		const { cultures, alertData } = this.props;

		if (!cultures) {
			return <Preloader />
		}

		return (
			<form className="custom-form">
				{alertData.messageShowed ?
					<div className="clearfix">
						<div className={`alert alert-${alertData.type} col-xs-5`}>
							{alertData.text}
						</div>
					</div> : null
				}
				<h4>Добавить культуру</h4>
				<div className="clearfix mr-bottom-20">
					<div className="col-xs-3">
						<label className="custom-form__label">Название культуры</label>
						<input className="custom-form__input" ref={c => this.newCulture = c} type="text" onChange={this.handleInputChange} data-field="newCulture" value={newCulture} />
					</div>
					<div className="col-xs-4">
						<div className="mr-left-20 cols-with-no-label">
							<button className="btn btn-success" onClick={this.handleAddClick} disabled={!newCulture}>Добавить</button>
						</div>
					</div>
				</div>
				<h4>Изменить культуру</h4>
				<div className="clearfix mr-bottom-20">
					<div className="col-xs-3">
						<div className="mr-right-20">
							<label className="custom-form__label">Культура</label>
							<CustomSelect
								placeholder="Выберите культуру"
								options={cultures}
								name="culture"
								onSelect={this.handleSelectChange}
								values={culture}
							/>
						</div>
					</div>
					<div className="col-xs-3">
						<div className="mr-right-20">
							<label className="custom-form__label">Новое название</label>
							e{/* Запросы на onChane */}
							<input className="custom-form__input" type="text" onBlur={this.handleInputChange} data-field="changedCulture" value={changedCulture} />
						</div>
					</div>
					<div className="col-xs-1 cols-with-no-label mr-right-20"><button className="btn btn-warning" disabled={!changedCulture} onClick={this.handleSaveClick}>Изменить</button></div>
					<div className="col-xs-1 cols-with-no-label"><button className="btn btn-danger" disabled={!changedCulture} onClick={this.handleRemoveClick}>Удалить</button></div>
				</div>
			</form>
		);
	}
}

Cultures.propTypes = {
	cultures: PropTypes.array,
	loadCultures: PropTypes.func.isRequired,
	saveCulture: PropTypes.func.isRequired,
	deleteCulture: PropTypes.func.isRequired,
	alertData: PropTypes.object
};

const mapStateToProps = state => ({
	cultures: state.webInterface.initData ? state.webInterface.initData.cultures : []
});

const mapDispatchToProps = dispatch => ({
	loadCultures: () => dispatch(loadCultures()),
	saveCulture: data => dispatch(saveCulture(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Cultures);



// WEBPACK FOOTER //
// ./components/SettingsForms/Cultures.js